import { FC } from 'react'

import InterferenceMap from './aboutChildren/interferenceMap';
import LiveView from './aboutChildren/liveView';
import Observatory from './aboutChildren/observatory';
import ProjectDescription from './aboutChildren/projectDescription';
import Archival from './mainViewChildren/archival';
import RadioSpectrogram from './mainViewChildren/radioSpectrogram';
import SolarFluxLive from './mainViewChildren/solarFluxLive';
import SolarIndices from './mainViewChildren/solarIndices';
import AboutFIndex from './physicsChildren/aboutfindex';
import Heliophysics from './physicsChildren/heliophysics';
import SpaceWeather from './physicsChildren/spaceweather';

import Form from '../components/Alerts/components/Form/Form';
import GeneralInformation from '../components/Alerts/components/GeneralInformation/GeneralInformation';

import About from '../screens/About';
import Alerts from '../screens/Alerts';
import MainView from '../screens/MainView';
import Physics from '../screens/Physics';




interface MenuItem {
  url: string
  text: string
  component: FC
  visibleInMenu?: boolean
  children?: Array<MenuItem>
  indexElement?: boolean
}

interface Menu {
  headerHeight: number
  width: number
  items: MenuItem[]
}

const menu: Menu = {
  headerHeight: 60,
  width: 230,
  items: [
    {
      url: '/',
      text: 'MainView',
      component: MainView,
      visibleInMenu: true,
      children: [
        {
          url: '/',
          text: 'Solar Flux Live',
          component: SolarFluxLive,
          visibleInMenu: true,
          indexElement: true,
        },
        {
          url: '/archival',
          text: 'Data archive',
          component: Archival,
          visibleInMenu: true,
        },
        {
          url: '/solarIndexes',
          text: 'Solar indexes',
          component: SolarIndices,
          visibleInMenu: true,
        },
        {
          url: '/radioSpectrogram',
          text: 'Radio Spectrograms',
          component: RadioSpectrogram,
          visibleInMenu: true,
        },
      ],
    },
    {
      url: '/about',
      text: 'About',
      component: About,
      visibleInMenu: false,
      children: [
        {
          url: '/about/description',
          text: 'Project description',
          component: ProjectDescription,
          visibleInMenu: true,
        },
        {
          url: '/about/observatory',
          text: 'Observatory',
          component: Observatory,
          visibleInMenu: true,
        },
        {
          url: '/about/live',
          text: 'Receiver live view',
          component: LiveView,
          visibleInMenu: true,
        },
        {
          url: '/about/interference',
          text: 'Interference map',
          component: InterferenceMap,
          visibleInMenu: true,
        },
      ],
    },
    {
      url: '/physics',
      text: 'Physics',
      component: Physics,
      visibleInMenu: false,
      children: [
        {
          url: '/physics/Heliophysics',
          text: 'Heliophysics',
          component: Heliophysics,
          visibleInMenu: true,
        },
        {
          url: '/physics/aboutfindex',
          text: 'About F10.7 and F30 indices',
          component: AboutFIndex,
          visibleInMenu: true,
        },
        {
          url: '/physics/spaceWeather',
          text: 'Space Weather',
          component: SpaceWeather,
          visibleInMenu: true,
        },
      ],
    },
    {
      url: '/alerts',
      text: 'Alerts',
      component: Alerts,
      visibleInMenu: false,
      children: [
        {
          url: '/alerts/general',
          text: 'General information',
          component: GeneralInformation,
          visibleInMenu: true,
        },
        {
          url: '/alerts/form',
          text: 'Form',
          component: Form,
          visibleInMenu: true,
        }
      ],
    },
  ],
}

export default menu
